export enum FilterEventType {
    APPLY = 'apply',
    CLOSE = 'close',
    REMOVE = 'remove',
    RESET = 'reset',
}
